import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { formSubmitWithWaitForJobCompletion } from "../../../../scripts/jobCompletion";

export default class DeleteController extends Controller {
    static targets = [
        "form",
        "submit"
    ];

    static values = {
        getJobUrl: String,
        phonemesIndexUrl : String
    };

    readonly formTarget!: HTMLElement;
    readonly submitTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    readonly phonemesIndexUrlValue!: string;

    connect() {
        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitTarget),
            this.getJobUrlValue,
            () => {
                Turbo.visit(this.phonemesIndexUrlValue);
            }
        );
    }
}
